import {
  NetworkIndex,
  Address,
  Networks,
  NetworkFactoryIndex,
  Factory,
} from "impermax-sdk";

export const DISTRIBUTORS: NetworkIndex<
  Array<{
    claimableAddress: Address;
    name: string;
  }>
> = {
  [Networks.Ropsten]: [
    {
      claimableAddress: "0x3bE7B59Ab6558845FfA1f026Dff40b305dd47b37",
      name: "Vested IBEX",
    },
  ],
  [Networks.Mainnet]: [
    {
      claimableAddress: "0xaF82Ee9246a608484E8567FadBEF64Ac1B8a87aB",
      name: "Vested IBEX",
    },
  ],
  [Networks.Polygon]: [],
  [Networks.Arbitrum]: [],
  [Networks.Avalanche]: [],
  [Networks.Moonriver]: [],
  [Networks.Aurora]: [],
  [Networks.Cronos]: [],
  [Networks.Fantom]: [],
  [Networks.Harmony]: [],
  [Networks.Moonbeam]: [],
  [Networks.Sxnetwork]: [],
  [Networks.Canto]: [],
  [Networks.ZksyncEra]: [],
  [Networks.Base]: [],
  [Networks.Mantle]: [],
  [Networks.Scroll]: [],
  [Networks.Real]: [],
  [Networks.Optimism]: [],
  [Networks.Blast]: [],
  [Networks.Sonic]: [],
  [Networks.Linea]: [],
  [Networks.HyperEVM]: []
};

// Whitelisted Pairs

export const WHITELISTED_PAIRS: NetworkFactoryIndex<Address[]> = {
  [Networks.Ropsten]: {},
  [Networks.Mainnet]: {
    [Factory.V2V1]: [
      "0x3041cbd36888becc7bbcbc0045e3b1f144466f5f", //USDC-USDT
      "0xbb2b8038a1640196fbe3e38816f3e67cba72d940", //WBTC-ETH
      "0xa478c2975ab1ea89e8196811f51a7b7ade33eb11", //DAI-ETH
      "0xd3d2e2692501a5c9ca623199d38826e513033a17", //UNI-ETH
      "0x4d5ef58aac27d99935e5b6b4a6778ff292059991", //DPI-ETH
      "0xb4e16d0168e52d35cacd2c6185b44281ec28c9dc", //USDC-ETH
      "0x0d4a11d5eeaac28ec3f61d100daf4d40471f1852", //USDT-ETH
      "0xa2107fa5b38d9bbd2c461d6edf11b11a50f6b974", //LINK-ETH
      "0xdfc14d2af169b0d36c4eff567ada9b2e0cae044f", //AAVE-ETH
      "0x819f3450da6f110ba6ea52195b3beafa246062de", //MATIC-ETH
      "0xcffdded873554f362ac02f8fb1f02e5ada10516f", //COMP-ETH
      "0x43ae24960e5534731fc831386c07755a2dc33d47", //SNX-ETH
      "0x3da1313ae46132a397d90d95b1424a9a7e3e0fce", //CRV-ETH
      "0xa5e79baee540f000ef6f23d067cd3ac22c7d9fe6", //LINK-ETH
      "0x2fdbadf3c4d5a8666bc06645b8358ab803996e28", //YFI-ETH
    ],
  },
  [Networks.Polygon]: {
    [Factory.V2V1_1]: [
      // QuickSwap
      "0x8f7F8a534F6a7d57FbdA855Cf3588eB1eDc4508B", //WBTC-ETH
      "0xc380e7FA325E1708e9E6eF4D9beD2CD806fcB328", //WETH-USDC
      "0x2912A338DF9877905e54c557e4d826f84365602e", //WETH-USDT
      "0x16AEd35D0c1f5500b73063b10C0dAd42B772ac23", //DAI-WETH
      "0x3e115a3aF5a58C73571586468B0f5d08BfE9dab1", //USDC-USDT
      "0xc3a4C0677b033BF6e9a4E22f930f1D60c5Cd2c86", //MAI-USDT
      "0x6D59C06a7f96a508310A76Da84dB397819E29c62", //DAI-MAI
      "0xc6c866c2C69FF093E14746E6F9dbc7A22E0e6522", //AAVE-WETH
      "0x0c7fEaa175F62779be13cDD4Fe878e55Ee70179e", //LINK-WETH
      "0xb361E254dAe512A7bd37f72B926f625f4D39dB56", //UNI-WETH
      "0xb48E8C226facb7aDE62ab0CA8588789aAA1428aA", //QI-WETH
      "0x205995421c72dc223f36bbfad78b66eea72d2677", //JPYCv1-USDC
      "0xd83a3ddC19A651F79970291d71b41Be5509e7c66", //DPI-WETH
      "0xE1ad5D74f3fEdE7Ec63Fec63D4bAFe9afbF09eDB", //pBTC-wBTC
      // QuickSwap Dual Reward
      "0x1714f3d4C4654bd5afD0Ff2590d23b053e0BEA81", //WETH-MATIC
      "0xe74189ce423345967Ef5A646316Ece52BB2fbFC9", //USDC-MATIC
      "0x14a49B53B62f7037814d4F5cAb8C92F185d045B0", //USDT-MATIC
      // SushiSwap
      "0xbb7cCc9c0f72Fb91DEE7053C652E961117DB4368", //ETH-USDC
      "0x9B2f10eAE09fAd574B3f76b977c06634a4Ec3a46", //USDC-USDT
      "0x542cCc962097B184Ca12A46030D967a735342cF8", //USDC-DAI
      "0x7DA257e84f233C9d05959F923c797585549bb3CB", //ETH-WBTC
      "0x9039b60EeE1aDBD2697A0fFb558f879c0b5D87bb", //ETH-CRV
      "0xC2Eb7FC0C27B20400e9923a1f4066D8D4a9cd203", //ETH-AVAX
      "0xCB8F6c44C85f4a55f243df1D1f339a52a452aCa5", //ETH-MATIC
      "0xb5846453b67d0b4b4ce655930cf6e4129f4416d7", //ETH-SUSHI
      "0xa13C38e12B1d516634dCFeB80ABE620aEDFcf0D0", //ETH-MVI
      "0x3DF6b9fdDB088d0B367aCF32F2975B6613De87a9", //ETH-gOHM
      "0x34310CE0a22A7e6142c66B5334CE3C91d3892313", //ETH-SX
      // TetuSwap
      //"0xCB9A1bf72BE38A9cE7ac781D2deab19eb7f0a03A", //TETU-USDC
    ],
    [Factory.V2V2]: [
      // for quickswap partnership
      // QuickSwap
      "0xe186dac06f75e7e2655db05a7c684289eaa19179", //IBEX-WETH
      "0x1714f3d4C4654bd5afD0Ff2590d23b053e0BEA81", //WETH-MATIC
      "0xe74189ce423345967ef5a646316ece52bb2fbfc9", //USDC-MATIC
      "0x14a49B53B62f7037814d4F5cAb8C92F185d045B0", //USDT-MATIC
      "0x59377dbd9f550568540cae0b21412bee1cc3f439", //JPYCv2-USDC
      "0x2912a338df9877905e54c557e4d826f84365602e", //ETH-USDT
      "0xc380e7fa325e1708e9e6ef4d9bed2cd806fcb328", //ETH-USDC
      "0x3e115a3af5a58c73571586468b0f5d08bfe9dab1", //USDC-USDT
      "0x8f7f8a534f6a7d57fbda855cf3588eb1edc4508b", //ETH-BTC
      "0xc3a4c0677b033bf6e9a4e22f930f1d60c5cd2c86", //MAI-USDT
      "0x8ab6ea95C3c8d4d415D531c18ee3e6B14A1a3Cc2", //PAXG-USDC
      "0xf189C676a837B973F83A55eAFD187E322F8E4Cfe", //LDO-MATIC
      "0xf9221c5EDC736D26ffC4dDCcDDfA15A4B958862e", //GNS-DAI
    ],
    [Factory.SOLV2]: [],
    [Factory.SOL_STABLE]: [],
  },
  [Networks.Arbitrum]: {
    [Factory.V2V1_1]: [
      // SushiSwap
      "0xB0e7Ad5053414fDe098122B61fd34D816fd6D93f", //ETH-USDC
      "0x7532A8d8a12BDd871796a07aC90E510b1CC8f694", //ETH-WBTC
      "0x95c9bF3f60Cbc2BE8e148FAe82f26930bFcD1839", //ETH-USDT
      "0xa6E69dD0C36F3b59539e2c7aFD274eF91b5c70F9", //ETH-MIM
      //"0xeF7Fa2D462dd5466AcFDe19D0143A1474bcC84b5", //ETH-LINK
      //"0x9cbA44088FeC97C14b850D067f94e38f274c27d5", //ETH-DPX
      //"0xaCacB091B65E8291A227afF563e023ee6E6dF219", //ETH-RDPX
      "0x6D94F7e67C6ae0B0257C35754e059FDfB249d998", //ETH-gOHM
      "0x88a0B00BBE918eE00e3482F71962070Dc052984b", //ETH-MAGIC
    ],
    [Factory.V2V2]: [
      "0x6024C3e62D8e774A498f7911aE6874b1AFDA4364", //ETH-PLS
      // Arbidex
      "0x116852f076Fac0050De7E12aa0b7Ce86B33cC422", //ARX-USDC
      "0x82062777dC9ff32D9D2aC1242e76A9f122431A58", //ETH-WBTC
      "0x478DE28185959cc5C553C0677ddC6e2e11629BC0", //ETH-USDC
      "0x5B4AeE12f8e6884E81661e360954420857448ae2", //USDC-WBTC
      "0xfd99357DD35Fa2ed55103abc8b1bDA02E3E605F2", //ETH-ARB
      "0xd4406836f1511e86E91dC64Dd14FbFA682D69f0d", //USDC-ARB
    ],
    [Factory.SOLV2]: [
      // SolidLizard
      "0x699c5e23357aB1BF658bD0B38070d746E37671f3", //ETH-LIZ
      "0x2d2ee5838838a1131995509346c9C9848b3367d8", //IBEX-ETH
      "0x32FaA88478A0104154e9417C6F7b4Fa288f728Aa", //L2DAO-ETH
      "0x4B28550846405A7825247F54070b568C2ECe3eEB", //SLIZ-opxveSLIZ
      // Auragi
      "0x2D658A6a569139f84d8c2f4e37Eed04F19EAB37D", //IBEX-ETH
      // Chronos
      "0x350954bf706B296CBFDf58fBFEDe91Ac4A271BEa", //IBEX-ETH
      "0xd4d45B476197b10da32ce58E669Bae8bdF0f7E16", //IBEX-USDC
      "0x7cA9a0140EE27ed4dF141DEab53088a69CCC4Cf8", //CHR-USDC
      "0x21E885fe81731ae391717Afb0513Dd0dF364fe06", //ETH-ARB
      "0x06507308ef73937E96f33c9defb6BE7F65cbc13c", //IBEX-ARB
      "0x8DC16595ac492056d9C59470685E3AB296E8322f", //CHR-ETH
      "0xA633615b835DBdF89C3f2B5420048B3201638E4a", //ARB-USDC
      "0x01a464e2BF76Bd4A3A50073026fF2335584D67d8", //GND-gmUSD
      "0x7b4975F5C3BE5735714F597D7af6877bDD68Bf13", //rETH-ETH
      "0x3d5FCbEd1c9B6C9B0f6deA1DED55b161a6eFeF31", //BELA-ETH
      "0x4941007F424336a682B478993dBDAF0a444d82fc", //GNS-USDC
      "0x39680ed7d9267e3AFe7239D2930361CBee996207", //GNS-ETH
    ],
  },
  [Networks.Avalanche]: {
    [Factory.V2V1_2]: [
      // Pangolin V2
      "0x6Ca300f7B764580e52889341E8941CcA7CfCA727", //SPEL-AVAX
      "0x7140D22AFC110741323ef29868c48b566a3295D4", //WBTC-AVAX
      "0xc532a2885027677c4BE61F710F7D41941dBaD1B1", //ETH-AVAX
      "0x734ee20bBaD6d191432B34FbFd1493c16f065E9C", //USDT-AVAX
      "0x5b588F4481035B0f765393FC9F4752615a6D0498", //sAVAX-AVAX
      // Pangolin-BenQI
      "0x3e2a4Dcd46e0e339aEC603080D90Bd939a163062", //QI-AVAX
    ],
    [Factory.V2V2]: [],
    [Factory.SOLV2]: [
      "0x05dc8e14a5779f27ddd1adcafc0acb19b65a71d1", // super/usdc
      "0x62ad2d9c575fe1dad4833c1f8dcdda9ce37e59f4", // usdc/black
      "0x4b6d205c81c392defad31965019a26c37063f3a7", // super/black
      "0xeec03faa348776a921cb75f764c6217b61d2276a", //  btc.b/avax
      "0x5c42e92ab5d3b4864caf1bdcaf388dc88cc0bd16", // avax/ket
      "0x410a91adf62172e832ccb5c653e7ea4369639b77", // champ/usdc
      //"0xc061b9f143325767439603dd861d7df1ac9f5300", // weth/avax -> redeployed in v2
      //"0x8b48bc4bd0d9568bb39b38e652d20352e170f9ac"  // weth/fbomb -> redeployed in v2
      "0x0b96755241DeAccc83BF8b4eda314d81905Cd7Bd", // weth/avax
      "0x4f667a0220EF7c1284C763c33eD86f9413a177B3", // weth/fbom
      "0x375Ff4A46EB1E75F702e9BE411bf0Ac96D8E55dD", // fbomb/avax
      "0x679D91d08EB980c6f1B69632ECA139F006E4b914", // id/avax
      "0x237dC61F6346e931A0Ff8801D8cAB566cE1c7F94", // fbomb/black
      "0x03e92DF133Fa319e55D806687c46118072532433",  // fbomb/usdc
      "0x6c7BA123072d095482182Edf73e3d664fa124A46",   // anon/avax
      "0x0CAa27a5570C94dA35Bf8EAE5d67f0e25aa4fF69", // id/black
      "0xa871F7137677d5323fB0451e456453465f322B45"  // champ/black
    ],
  },
  [Networks.Moonriver]: {
    [Factory.V2V1_2]: [
      // // SolarBeam V2
      // "0x899CaAd2d29EFf3b628503A85DAE736B5c4d1671", //ETH-MOVR
      // "0x24e19bD8477077B80DE25Ee7FC9F7A67D89D8009", //WBTC-MOVR
      // "0x2748d9d4E7379D5D29CA8887aeFF929912fF06D8", //MIM-MOVR
      // "0x35e8f2D87821a5149d92833390880F65911AD4d0", //FRAX-MOVR
      // // SolarBeam V3
      // "0x4683e366aa2D3e7Cb1a776Db6c8efCbcb143cD17", //ETH-MOVR
      // "0xAce2a03b7937fDdf40B33F7229381575Abb99DB3", //USDC-MOVR
      // // SushiSwap
      // //"0xDB45ddcE0216F7920CfBcbE26804c6E50B667960", //ETH-MOVR
    ],
  },
  [Networks.Aurora]: {},
  [Networks.Cronos]: {},
  [Networks.Fantom]: {
    [Factory.SOLV1_2]: [],
    [Factory.SOLV2]: [
      "0xba54c573602B0634103c557D0D423Ac6A7D715E2", // WFTM/PLUS
      "0xF33E4010E3D999934AF01e431416Ba756a315748", // fSONIC/WFTM
      "0xC85916A8932E192D56AeB6E815db97CF9160A67A", // WFTM/TANGO
      "0x8861B1529Ed0540e2FF6807C7A0459d9185C6317", // WFTM/sGOAT
      "0x0dB7D5e629BF05b106cC8ec5C00976c626A22118", // WFTM/BAY
      "0x165050d12BdA924b2C2714c890452c8833bb7403", // EQUAL/HOOPS
      "0x76481a638Edf95019cfbc2f49Cc2645dAC7D70Ed", // WFTM/ECO
      "0x59e0885E3B74dC1dB9519729a94DA6fEcb3c1848", // UPONLY/EQUAL
      "0x0427f80e7B38Fd752245bA68f6d4E3d9cF089d6f", // WFTM/THC
      "0x0dbc4a7163fe5677eef03a9c67a1e88fefffa724", // WFTM/EQUAL
      "0x1f7c6a86cfba2fd1992be43b39796c1be0112a88", // MCLB/fBomb
      "0x75fbe02e6a0e124d0fe82cdb8acc317cea85c8ba", // MFTM/fiery
      "0x38c17f311399fc1233b74f8b0327d64a7c2551fe",  // WFTM/skitty
      "0x9eC34839311337c08605C3eEB79dD9e2841d9243", // hedgy/wftm
    ],
    [Factory.V2V2]: [
      "0xd06a1Cb26e64F043f49029Ec88Fe63eA51547253", // wigo/wftm
      "0xb0Df6B8e48F246f48C65D1a96E1B28fa5EE39E33", // axlusdc/wftm
      "0x68E3710b960d126Bc639220bebAEd03450877494", // usdc/wftm
      "0x77BE8e1e6ffeC7c96C7363B89f3B6f18D65b5C02", // usdc.e/wftm
      "0x881cf143aC3d1dAb5F82e1c8Ce7EF6CA6191099c", // lumos/wftm
    ]
  },
  [Networks.Canto]: {
    [Factory.SOLV2]: [
      // // Velocimeter
      // "0x921c11519444231c84fDDAc2eCbCf7C84F25730A", //CANTO-FLOW
      // "0x5C32443985B599605a3c1C6Eb96b274BAe95062a", //CANTO-NOTE
      // "0x63c544591Ce03E097813422FD30e886A54ed540E", //CANTO-ETH
      // "0x2E33A768A2461Acce69e54102074737B91EDF7e3", //FLOW-NOTE
      // "0xAf4846A2d46562965fa008761790817D922834F6", //FLOW-ETH
      // "0xBd437c716da4a1A1c5BD004764300dFF72DfBCC0", //CANTO-ATOM
      // "0x22456D98a75fd0540418921372a85C2b54E57F2d", //IBEX-NOTE
      // "0x5BDf174963b1a8D7253a6Dff9788D3c619C31E96", //CBONK-CANTO
      // "0x528aCfc1C53C95d97f2540754C035c732EF291B7", //multiBTC-ETH
      // "0x91b7711b7f91B3B999A2a2B71fc00323cf381eAb", //multiBTC-NOTE
      // "0xc5a7Dab3897cb0f6f168d3F3b5f8335E50EEc661", //multiBTC-FLOW
      // "0x55E7b42aDE0D33A4720850c6Ccb940130767736d", //ETH-stETH
    ],
  },
  [Networks.ZksyncEra]: {
    [Factory.SOLV2]: [
      // Velocore
      "0x0C468E366B9ae76ca43acc90be049711c7E7B6d7", //ETH-USDC
      "0xE2f69aE6770d777A21fe3ffd781Dc640B4d36b18", //ETH-VC
      "0x304847Ddbf68948655b0209c00E32A0923eF41B6", //ETH-IBEX
      "0x1B5887722E9E8E74426c057a1fabb40395dCB1e5", //ETH-LIBERA
      "0x572261bc2F1652dC8B2C6Ea9d5bF7B3699DcB1bC", //RF-ETH
      // VeSync
      "0xc9Fb969F3770387C0A634C9fa4656B268404A2Db", //ETH-IBEX
      "0x1fD9e25a7D3FD1ba151Fb7C9353aBB45b908d5D2", //ETH-USDC
      "0x0d72322A1C86B1dF92711327a38a79a5679e478f", //ETH-VS
      "0x8d535eFa82481CdefBe7801E562736017Bc59872", //LUSD-USDC
      //"0x2907ab8286Bd0438064816f6CCf1bf688Ec70A56", //wTBT-USDC
      // Dracula
      "0xc73195F2B5D60A59F81f88A3ec77BBF4555faB57", //ETH-IBEX
      "0xbaDde16f4ED28B3f2118942c521cA0eF6A2c6e01", //ETH-USDC
      "0xD2905ec6172A956f4E79C8DCee4e9470dA587Da3", //FANG-USDC
    ],
  },
  [Networks.Harmony]: {},
  [Networks.Moonbeam]: {},
  [Networks.Sxnetwork]: {},
  [Networks.Base]: {
    [Factory.SOLV2]: [
      // Aerodrome
      // "0x75eAFf00a93177B17D14982B097Baf38D4b221B9", // weth/aero - stakedlp
      // "0x465300EbA2C61E3c6d71BC79078eEf45965ced01", // eth/degen - stakedlp
      "0xd118880d725C49256f372881a73F25121092935F", // eth/usdc - stakedlp
      "0x34FD2AfefD64319eBAeFcc0d64b8110679488608", // usdc/aero - stakedlp
      "0x352004829Ed5a80491B94A7cA75ce38cdAAABA93", // wsteth/fbomb - stakedlp
      "0x132d4cCe8EfB32060991E2e5Df9f89322A89625E", // cbeth/fbomb - stakedlp
      "0xFE970BE08531deaD94B0E1bc01A1cCF652e2bd29", // eth/fbomb - stakedlp
      "0xcdc35f924875F2809e358808Fe7A733574e59F39", // ovn/usd+ - stakedlp
      "0x670b06d8944C71d39Fe602996285172a4190B87d", // fbomb/aero - stakedlp
      "0xe99e6d45972fBBc5E2F1Bef92501d2bf5ab33F0d", // ogn/superOETHb - stakedlp
      "0xAa9F575a3fBF36d54FA3270fE25D4bB7Bb3bA3aE", // fBOMB/cbBTC - stakedlp
      "0x3F90A20a46a998D0875ad012ee315b1226c91Ade", // tkn/aero - stakedlp
      "0x1201055A23252604A859c7211EE3469Da46E6C5d", // tkn/eth - stakedlp
      "0x3Ff0669f82abEE4183841d4a86ebf45F10FDe0E8", // tkn/usd+ - stakedlp
      "0xFA7dE3049Ad98E7E2735897FebD1a58ddd2747E1", // weth/met - stakedlp
      "0xDC932b16933ff168c98930EA3391f3E84FbE6661", // wels/weth - stakedlp
      "0x4FbC8c41EB701aa183283B91a94A38936e69d7Dd", // bct/usdc - stakedlp
      "0x1302121f03aDC3C284E2294cb5ff038A70BA87d6", // weth/pdt - stakedlp
      "0xf0c5fcc6fc3e551c2326724cd5000a0a2bff9cf3", // weth/klima - stakedlp
      "0x63FD32d4B2702877DcB1321E94723F794Bb24487", // usdc/klima - stakedlp
      "0xc63f7699b14bb87cd3e3F7a6Fe9A5Fdb491D974E", // icl/weth - stakedlp
      "0xd8Ff3a920A36034e8850d5F8CEA455b423Cfd8FF", // eth/dog stakedlp
      "0xb66183b686A0376fADa1A5F6EB1d06EDD6cf1052", // virtual/cbbtc stakedlp
      "0x31A67865D746B1b48F65F7bAE316d843309e0A5C", // weth/cbbtc stakedlp
      "0x4c1AB9B6d2719b0678a41f090D9c0E186a23CE13", // usdc/cbbtc stakedlp
      "0x0FEa7116F23eF13796835E52eD8A1f1b491A7DBD", // weth/pegg stakedlp
      "0xF53Ae008c8e93cE42AE3A1fA7c7AD3ef86750FeD", // pegg/aero stakedlp
      "0x95e5cBbb8678c81B3Fc3Adf5D15f72cf3dc2c887", // anz/eth stakedlp
      // "0xaCE71E660eb93867a1233163B4447F20c056FDBf", // tbtc/usdc stakedlp
      "0xFd6b42A3da0e755d647D1eBF522E7D4368D7fEf7", // eth/symm stakedlp
      "0xB8e831D4eb4Ce93ffca9Ff4A8fe2c3f9bF99628A", // anon/usdc stakedlp
      "0xb5E2500f93Bc2DD3163E191EBc6F3B2f5B1E8b7f", // met/usdc stakedlp
      "0xc612250083ad9a3b1b07616f7832d0ba11cef227", // synd/weth stakedlp
      "0xe2a738197977c3135796ae45b3b847f1126489e0", // eth/veil stakedlp
      "0x697547342a5969b805f6f01924bbfe62e5c71cab", // kvcm/usdc stakedlp
      "0xa3e83ebef780c6340be10a745b75e2628657ca08", // kvcm/eth stakedlp

      // Scale
      "0x4Cafce8b0Ca0Ba9d3490Ce9b67048139f698a5f8", // usdc/axlOP staked-lp
      "0x965c3f8Dc3aa446b268aB3Bca4d7E82b788FfE96", // eth/scale - stakedlp
      "0x6d78d00b8B201B67fA6433B309ccF9A60b7A6dc0", // scale/axlOP - stakedlp
      "0x7e07b19d7fdd7589e83c04b18c7e3ad4eed7e5c9", // scale/fbomb - stakedlp
      "0xb3a32005027fE489603D3e0C4Ed1e6cd80976fb1", // surv/eth - stakedlp
      "0x7da514CdC7668cfEA4439d0CB005f1ea8602b31d", // tad/weth - stakedlp
      "0xc588e089e2c6ed18c8ac58eb6e899e9969902890", // thro/weth - satkedlp
      "0x6525eB26D0Ee3b095727082Bb6358149118D7E58", // fuego/scale - stakedlp
      "0x1DED990e0530452276A6DCC885fBFbECB19FA513", // spectra/superoeth stakedlp
      "0x74457A8312917df301c0F5910e19981a2d57cAf4", // spectra/usdc stakedlp

    ],
    [Factory.V2V2]: [
      // uniswap
      "0x88A43bbDF9D098eEC7bCEda4e2494615dfD9bB9C", // eth/usdc
      "0xE31c372a7Af875b3B5E0F3713B17ef51556da667", // weth/virtuals
      // "0x7712658B21822cc15155528A828906eA711A6AB8", // dgz/usdc
      // "0x16905890A1D02b6F824387419319Bf4188B961b0", // eth/benji

      "0x69b83Ff5b0974988DadF48dc38b585c71afD8774", // alb/eth
      "0x03557e04a97Fd4415494Bf4a643Ef7eA1B6b3A86", // usdbc/eth
      "0xC72CFD366a292A8dD42747FD9022Dcf776C3e482", // alb/usdbc
      "0x711c56a47c7c72b586486D3a77587255bEAe2F39", // cbeth/eth
    ],
    [Factory.SOL_STABLE]: [
      "0x2A836212878F490169Df4Bd7a04CFC74Ba41A364", // usdc/star - stakedlp
      "0x6FbE55d65f5484c2B520e11FB1688C1faF7B9A59", // jERU/ERUA - stakedlp
      "0x17dde3af36da361029094ccadd6468dfdff518b8", // usdc/msusd - stakedlp
      "0xa50497633cccaf7f77d31dd9a379dab6ea8b2077", // mseth/eth - stakedlp

      // scale stable
      "0x656629d6921B9697BBFD791e7e4e8c09E160459E", //usdc/dsxusd stakedlp
      "0x4c7c80Cb67e88486442474F518876819dcEa8A00", // eth/superoethb stakedlp
    ]
  },
  [Networks.Mantle]: {
    [Factory.V2V2]: [
      "0xba5E281a7e0197a685534bae1606f650Cf4fbB55",
      "0x6fd0cB9b9DB27446F833807084Ea2FaDBcBe822A",
      "0x0Ae5F81eD785bd0a82FD7555181a3566D52cAFA2",
      "0x221972d1Ee7e3175200268F8a5c350B54fBE4745",
      "0x736f7D3bD6a2b829dFA5B9501b873675d0165d21",
    ]
  },
  [Networks.Scroll]: {
    [Factory.SOLV2]: [
      "0xE3167f148F3C97dea3D42cb9d6848a7d28b3A296", // zen/chi - stakedlp
      "0xFA444f62379619BDa05842f70fE13c5469B238F6", // chi/weth - stakedlp
      "0x88b5068c4ED14d69C7093011149E7d5E93a0a98e", // ibex/weth - stakedlp
      "0xD30eDb2f0CA35cba70d10bd3fcCe5Bbb317C88C7", // wstETH/weth - stakedlp
      "0x8A16A1CA6c303122E5FA985150A2b742B3aA5FB7", // fBomb/weth - stakedlp
      "0x185060149a0fA57aa93AFEBFaD052029129903b2", // weth/usdc - stakedlp
      "0x2072119D41ba1288cEEc5Cc8FD7b31A0fC9734fc", // weth/surv - stakedlp
      "0x0833C454fc94d32e03110081AC9b9AD2d54e18Fa", // preon/chi stakedlp
      "0x432C27EfeD615033A7F0c6320E9831332685EB53", // wstrwa/chi stakedlp
      "0xbD4b6e9992BEF375A14793b18D2A1CC8d710D45b", // fbomb/wsteth - stakedlp
      "0xd398411A691C81e50a1216e287bbe6D5F54Fe2Cc", // scr/chi stakedlp
      "0xDbbF2Fa67Cfa713b1Ab2376A0EEF1a34d6f9E8c6", // scr/weth stakedlp
    ],
    [Factory.SOL_STABLE]: [
      "0x354Df4F5925145409f76B044bf1E4BD3a5dCe74E", // weth/wrseth stakedlp
      "0xB0a3410C7672CC0759fF6DA3540a9A26083507dc", // weth/stone stakedlp
      "0x3E458C566e81869DCc1c84690441e29149Ee6D35", // usdc/usdt stakedlp
      "0x471819fAFe0C6Bc919Ae1FF4e7DbE67371c4b467", // usdc/more stakedlp
    ]
  },
  [Networks.Optimism]: {
    [Factory.SOLV2]: [
      "0x71bF625fa23c62206aE1Bc88c29Fcb23F27ABF8A", // usdc/velo - stakedlp
      "0xc7DB841432E7DfF5d6c370fF0DC32004f3734c4e", // op/velo - stakedlp
      "0xeFbABD64c1EfEeA680e7600791A34AA4b6f17461", // usdc.e/velo
      "0xB15E782DB81Ab7257a9b8BF3A2762A2ec3D0A7E3", // fbomb/velo
      "0xDfc62DbCB18c76ced61a9ABF36e046a48fEd055e", // wsteth/fbomb
      "0xB81E1BcC468f2dAdd554d51c0C813030bB539EdF", // weth/fbomb
      "0xB8C1B76063419ba4acA5790BC96E2EC28bFBb43a", // eth/velo
      "0x446de044c72BeB8365eEd4765d9cA45b56a97c7b", // opp/opxvelo
      "0x4111A6C15C1D227ED9C1b5de2732aB3115Bc1c2D", // weth/opp
    ],
    [Factory.SOL_STABLE]: [
      "0x1f9b5b2bf8e6969b56b663125a6dd5523d38bc21" // velo/opxVelo
    ]
  },
  [Networks.Real]: {
    [Factory.SOL_STABLE]: [
      "0x1615D2418872b0D525cf42b37F8BeD345B66f018", // more/usdc stakedlp
    ],
    [Factory.SOLV2]: [
      "0xa5c272f3A299B0d69D002AeA694ed127c1b67bcD", // arcusd/pearl stakedlp
      "0x8628FB4Ff04E371fD2B75899E73cCB7f3d0f08F9", // cbbtc/usdc stakedlp
    ]
  },
  [Networks.Blast]: {
    [Factory.SOLV2]: [
      "0xa147fa83FAa925c297A473D194C3ffb5B73EBbD3", // weth/ibex stakedlp
      "0x3B4103D4833B365705c65e1776fc27Fb0C79B138", // preon/star stakedlp
      "0xd9875AaA3bd9cEE97d61ac71F646F98a1952686F", // weth/sdk stakedlp
      "0x17Fc141c19576bFC932e7707f41039c79e43a941", // deth/eth stakedlp
      "0xe92A67A2f7403e341243Bf2042C4128132BD649B", // fdao/eth stakedlp
      "0x4D7E9Ba31C8B10be6f0ccff7C28A51B37A2D42Fe", // fbomb/eth stakedlp
      "0xf187aaA1A602abC0F62e4f0FB056ad8b256eAd56", // fnx/eth stakedlp
    ],
    [Factory.SOL_STABLE]: [
      "0xD9024415c0E230A0366D4606eCa9991638839B75", // usdb/dola
    ]
  },
  [Networks.Sonic]: {
    [Factory.SOLV2]: [
      // equalizer
      "0x176F7d0b8E639E97D219d4BBA364Bb783378bCC3", // ws/usdc.e stakedlp
      "0xd2fFd683f84aB8CEcFdDd97f412a692b1463d9e2", // equal/ws stakedlp
      "0xEd610411B68dBf8D42AdC576b1ffcF1D1bf2718C", // equal/usdc.e stakedlp
      "0x493E9efa8f3698C3005C5D935130e9cD9227aaE1", // weth/usdc.e stakedlp
      "0xD34CbB08263F85891B5587421767ad82f3260Cb6", // ws/eco stakedlp
      "0x5CF344c033DC6C8D3f5736204CF3Ea9CA4f785b9", // weth/equal stakedlp
      "0xa677eC0bE27608c2bDb4e2597f094fff472c8379", // ws/moon stakedlp
      "0x7e549Bae7D2ee4049d14E0e479C31829a7B68e0f", // ws/missor
      "0x9D7D2460F866CE20Ef2BEA8a574Da617f005Ca2c", // equal/eggs
      "0x15746E3298333E0fc1C77bd3f71810FFC5674F04", // equal/tribe
      "0x99774dfda556167ef111623376613e0727fa0b86", // equal/eliteRings

      // shadowswap
      "0x327B5fC08e36Afdde1De297621bb4569fFd83DDd", // ws/shadow
      "0xBDc8B85Cf8f7E82B6DD08816eBD9B7377997b3f2", // ws/mlcb
      "0xD5b6D2bD47C932a3d9D96F4ffBA94aEEaeEC156C", // ws/thc
      "0xb40479ed4b63F5b5592a548F0b6A41e342b71e87", // ws/stbl
      "0x7195d62A9E388ae21c7881CA29be8fadEb09379f", // usdc.e/stbl
      "0x4Fe98a7A0D242605Fa48Dafa58F60e9FA107049e", // usdc.e/x33
      "0x07465f1890b73fa75fc10966edfd8b1249b11ee2", // usdce/spin stakedlp
      //"0x94467fe36e8cf71aa1f2a6471060fb226ac1ff5d", // aSonUsdc/xUSDc stakedlp

      // swapx
      "0x3C3976aA3d8561D9AB15Fa5a726A626d242141a3", // ws/woof stakedlp
      "0x5a3B22Ece19FaF97302A1b941ed60CF430E4a3F4", // ws/hedge stakedlp
      "0x9bb7624F7b0b18E8b37BB3C18321AfC3DB0D42BA", // ws/goglz stakedlp
      "0xBc0768E96D6CdDB4EE7DfFd1B62b94AAEf892Cd9", // ws/sdog stakedlp
      "0xCf5159973F4D73Db93B0832ac61757688ccb434E", // ws/tysg stakedlp
      "0x6c421D411246F4cFf79fb3076DedaDA1c1C16815", // ws/fiery stakedlp
      "0x44E640FA2a6153935a14E3ea4591E2ac0B2416c2", // ws/bol stakedlp
      "0xF5BAe65cF33f3Be79e6F4cdA8fC1b3Aaf38c501b", // ws/fs stakedlp
      "0x52284B2c12eD5BAF8B598837A8406E1A65fDF18a", // os/fiery stakedlp
      "0xc7f43A975F28F83a4cb89C169F54845518f4d8D6", // ws/mclb stakedlp
      "0x7AC104B89d4ddd5a52f67C020D854FA17C0028E3", // usdc.e/stbl stakedlp
      "0x755bd89b5735eF9EC4036A049F831ACE285EB99e", // os/ghog stakedlp
      "0xc325D95d5e516C440BbB8dd6C98d3819BEEb5693", // fbomb/eggs stakedlp
    ],
    [Factory.SOL_STABLE]: [
      // equalizer stable
      "0x0DEf0f2d2Af81928e8c8646d8058E1f3d44096e9", // ws/stS stakedlp
      "0x98cfa5addcb937c205e35d2bef0885f969dcf958", // usdc.e/eliteRingsScUSD
      "0xc045e6283517c4b05424414FEABE814786Ae633a", // xusd/eliteRingsUSD
      "0xc49f877f44a821e40b8253f7cc988d17857db918", // sfrxusd/eliteRingsUSD
      "0xa66f8721a5cfcd07b7efcb951cdee35c5d630da0", // weth/eliteRingsScETH
    ]
  },
  [Networks.Linea]: {
    [Factory.SOLV2]: [
      // etherex
      "0x5d62c23961D8ad01B5B4B446477DED4C57863ed3", // eth/rex
      "0xD0c167809c3E6466BBf7cB3DdD8A253927937a82", // eth/fbomb
      "0x37aa7c58e56d1e60006f1fd2e699059e2661e229", // eth/ibex
      "0x5468ff957772276c6d0a06dc7ce083b273d3577a", // elite/frxusd
      "0xeC9D6Ec00d9858670887A26fBa44CAc644A2448d", // rex33/usdc
    ],
    [Factory.SOL_STABLE]: [
      // etherex
      "0xE76408A83427c2349810d1B38AF8E798c8f62c9B", // usdc/usdt stakedlp
      "0xd47f5752c7b171eC1B896120b875f4151F24fb57", // usdc/asusdc stakedlp
    ]
  },
  [Networks.HyperEVM]: {}
};

export const WHITELISTED_OLD: NetworkFactoryIndex<Address[]> = {
  [Networks.Ropsten]: {},
  [Networks.Mainnet]: {
    [Factory.V2V1]: [
      "0xc5ed7350e0fb3f780c756ba7d5d8539dc242a414", //DUCK-ETH
      "0x524ae259179691bd2d727cada0e1aa4e365824e9", //DEP-USDT
      "0xf91c12dae1313d0be5d7a27aa559b1171cc1eac5", //ETH2x-FLI-ETH
    ],
  },
  [Networks.Polygon]: {
    [Factory.V2V1_1]: [
      // QuickSwap
      "0xbc41a177773b1dd31f7205aae3eb1d693b447fb5", //MATIC-ETH
      "0x889401a4a126b9423a1f76a94a92d1c6b2aa09b3", //USDC-ETH
      "0x2c1206437adc091f0e00c1b64e42ec77f0171344", //USDT-ETH
      "0x867ed92b9db2be7eaaa0d5bddaccb0d5c8789351", //MATIC-QUICK
      "0x728AA43C902A7ec339889D66B69118a520068860", //WBTC-ETH
      "0xCa2CcE303de0780441D682cE8520D011A5580976", //USDC-USDT
      "0x670983A0AF5293e2493Bc4d5C5BF0D4EC329d04e", //DAI-USDC
      "0xC0a19F80743D6588f4c5C1B70a8706D4D6B8B611", //DAI-ETH
      "0x15e03c40F0fA1979e9CA97e7804D1B41bE20E354", //MATIC-POLYDOGE
      "0xA0CdE469636fE0fb2593f1729468f2b6cbeaEDd4", //MATIC-USDC
      "0x6E864D3E38F089d1fc26BDC1ac87E197f47741f0", //miMATIC-USDC
      "0x00f29782182b675A090FDea4C17f62da99AEB208", //USDC-QUICK
      "0x9189d81d0536eCE515921b726cb996Ff6811aFE0", //ETH-QUICK
      "0x00A079fa35e1341A552dBcb18b511F8A83b634A5", //AAVE-ETH
      "0x9a9496dBFF4DaF6AEFa296d49b1B9B71F04FA693", //LINK-ETH
      "0x0a5Ba357036250bE6E3552298e3F7A7E8e4b1270", //UNI-ETH
      "0x0fA4D1c15cA356507E4A7a02AE27808406255731", //QI-QUICK
      "0x0cE8F64F4822ca662DeEA8A889038e0bE9546001", //QI-ETH
      "0x520fa0e46cdc012934edd8e1108F0E43bF4376BC", //MAI-DAI
      "0xcD63567CF79C7DAA26EeDdF367129C7809A7DA32", //MAI-USDT
      "0x989c133E09604b4C8e0ca0cD692fa5570F670b48", //MATIC-QUICK
      "0x2bb779ce585a19A202ccC6e583968431b3F15eA8", //cxETH-cxADA
      "0x63489c42530234b8F5d1124d2e671129be32b3b5", //cxETH-cxDOGE
      "0x33DF8a72F92FB77b43f787cAC7A56697f2Ee54Ab", //cxETH-ETH
      "0x2383B93CFa6ddd9a7b35ddFfD8d527E7aB80b920", //WETH-MATIC -> not receiving reward
      "0x1e987756305C6506A8687E6CEB85872c48ceaa3B", //PNT-WETH
      "0xc753C8E920a6c35315da5D15e8cfcD5B014Fd280", //WCRO-MATIC
      "0xFf2b9aDa14F0E8002F8389497b86bFeCA63e8f58", //ETH-ETH2x-FLI
      // Sushiswap
      "0xBA8d0e69773c2f5D385968E42050f23B24b35E36", //WBTC-ibBTC
      "0x44559353f8edB965294c1448333369ca84dF6298", //ETH-IDLE
      "0xb343CC2378dcFf9A6F81b4eEe3d8ECdC88560f6A", //ETH-DATA
    ],
    [Factory.V2V2]: [
      // QuickSwap Dual Reward
      "0x2bb779ce585a19A202ccC6e583968431b3F15eA8", //cxETH-cxADA
      "0x63489c42530234b8F5d1124d2e671129be32b3b5", //cxETH-cxDOGE
      "0x33DF8a72F92FB77b43f787cAC7A56697f2Ee54Ab", //cxETH-ETH
    ],
    [Factory.SOLV2]: [
      // Satin
      "0xE4702e545F4bF51FD383d00F01Bc284Ec9B8aa64", //MATIC-WETH
      // PearlFi
      "0xE5dD1C9EDEdC3E790Be12C703f378dab5874e1e1", //USDR-wUSDR
      "0x242Dd049bE49e795cd60f0Da812dEEf7Cf4104dc", //USDR-CVR
    ],
    [Factory.SOL_STABLE]: [
      // PearlFi
      "0xD33222b9Dc924B134f1FeA0576C750D21f015276", //USDR-USDC
      "0xA11374A6F99DaE4944F6394BA95C89b8843Db448", //USDR-DAI
      "0x8664812b46Ee3914b0780Aa3Ce474F9D2f2A2e48", //USDR-USDT
    ],
  },
  [Networks.Arbitrum]: {
    [Factory.V2V1_1]: [
      // Sushiswap
      "0x092162807896509aFe042b7f839Ab30e1cA11670", //ETH-SUSHI
      "0x35b44b303EaCB71114AA62fE8dAe6f9c5DE0F680", //ETH-SPELL
      // Swapr
      "0xe965129938867a125F91a67E1b6D34d022bDA569", //DAI-ETH
      "0xD52C2e7fEae13aBbc9aC4861EF697F7210586696", //USDT-USDC
      "0xC48a16493B97BF90545793cF89884eDe71AaC39a", //LINK-ETH
      "0x4fefA59353636C64c5950Fd23c969CBaaB5E7BBa", //MKR-ETH
      "0x4062f4775BC001595838FBaAE38908b250Ee07cf", //SWPR-ETH
      "0xb8942A1c1bBb90272190269D42C2F1Dff2Fde3A4", //WBTC-ETH
      "0x82cDE182702841DaB46916738207123FE535909F", //USDC-ETH
    ],
    [Factory.V2V2]: [
      "0xFb468ad210d427D65c9a765a480649d5754cA325", //ETH-RDNT
      // SwapFish
      "0xd6F5C7Eb3d61a00610a81FB909Aa4033affA827b", //ETH-USDC
      "0x1EFB0E92315fAb41993b03075A49c314A1CbE1Eb", //USDC-MIM
      "0x1bE5e42f53B54F3eC887340Db1A7394a0A664c95", //USDC-DAI
      "0xeb45c2F38A2c6AE9dDca11DfBcfef50Dea5Cd293", //USDC-USDT
      "0xbeb61368A3e9c6b6ab43429FD0a5F27A4c6bC913", //FISH-USDT
      "0x507A83d094EF1166273bDd76d6951A46e2E521aD", //FISH-WETH
      "0x53bB2d5D32f7df195fE505726DC1cCC7148F69b1", //USDC-FRAX
      "0x78788627C5cf918738a3F8736CE210B2A280c688", //USDC-MAI
      // SwapFish
      "0xA6e90034d48a34CFE947537bfEd149De1B1020a5", //ETH-WBTC
      "0x9c1A8b6508b3cE4D517F47a7514917AAcd9478c7", //ETH-WSTETH
      // ZyberSwap
      "0x6730D587f90bDbE1Dc22290F13379ec181b4DE42", //ETH-ZYB
      "0x932106a46e4f7eA62f053a117dE707288B5BC2E3", //ETH-USDC
      "0x2AEFef983AC5e422D00e02E257e099f9feC6B790", //USDT-USDC
      "0x6b41459E33e4d13Ac33Fbf027FFc4f219501d93c", //USDC-ZYB
      "0xa860865558F7bA5d1FfB08801E263930f37f817F", //DAI-USDC
      // Arbidex
      "0x2f624bB98613b3B986Fc75A181c4bd6982E79027", //USDC-USD+
      "0x4C83b11E6740d013992Ad68a09E918df3fbB96f9", //USDC-USDT
    ],
    [Factory.SOLV2]: [
      // SolidLizard
      "0x1229aAC120Ae75301aB1c3A2A04ec14183493584", //ETH-USDC
      "0x463Ec151258370a07431068BB3BdC98B5a6bA18f", //USDC-LIZ
      "0x85de0B4E00e27fB197FF6aB705825f21Bc683a3f", //ETH-fBOMB
      "0xD191B203c893BEb5323c25D2efFbB3EA1f7dFd84", //SLIZ-fBOMB
      "0x9e9631f83832455FE4B83CC7Ed9D3460dbD03529", //RDNT-ETH
      "0x568683dc1FDC8828230896BfC20d6Eaf91f76239", //ARB-USDC
      "0x93b7Fa1cA35a8EFe7C7028fA39C0eDFd31408Fcd", //RDNT-ETH
      "0xce009c44e1645bc6d19c90ba440c618a42ae581d", //ETH-BTC
      "0x9FD694201330f511764919D53Ef397d5511c1daF", //ARB-ETH
      "0xCF49F93Ff15b0ab9D336F1D5C8697f12d95012c4", //xSHRAP-L2DAO
      // Auragi
      "0xD148f711b0d3AFfb925BD82ffbDA235F1935f363", //USDC-ETH
      "0xA6d13f44b5e76443805f6D6Ea64993bccfC624E7", //ARB-ETH
      "0xFfa9e477B4562bE95ee53d897C68223eB39a8fDd", //ARB-USDC
      "0x45af52828352460c40D63f1b185Dff189Fa0f9D6", //AGI-ETH
      //"0xb7980391B790d3871CDaa0a9BcD6F2c015AC10d2", //YFX-USDC
      // Chronos
      "0xd4C0C5fE189559d667D4D3549BaE9B5776BF0C2c", //ETH-USDC
      "0xDFa96f8Cc1D58f916b46Fb7f111ea6EfBD73b3DE", //fBOMB-ETH
      "0x24511Ed472dFA1C32b08423ef79AE441afC4657B", //GMD-gmUSD
      // Ramses
      "0xD14B5E104C5bDED73D1E7f760eDE500bEEe2716f", //ETH-USDC
      "0xe54D870fffE460774e731237a3E8B424ee1210EF", //ETH-RAM
      "0xf1054e318BF5DFc5d2ac131ea7e584edf96F575a", //USDC-RAM
      "0x020C325F593B327a43c8fA0073Cfd310BF944587", //L2DAO-ETH
      "0xcEC322a5aACF238287d1908F2c64644517090811", //ETH-MAGIC
      "0xb600D52952878Db5D7c7c0bE06389c85762f8222", //ETH-fBOMB
      "0x1C1cCD7199AFB175b425e9a1A910A3326f73FAa3", //ETH-xSHRAP
      // Solunea
      "0xee4fb41Ccb1dFA6E2cDE242FeBF96148FB82C6Ca", //ETH-USDC
      "0xfb34d0a9cEc3526e46b44f4d9d5d00dAA3C8C53e", //ARB-ETH
      "0x08f218D943970a1B77acA743ceB08429dF65F67e", //IBEX-ETH
    ],
  },
  [Networks.Avalanche]: {
    [Factory.V2V1_2]: [
      // Pangolin V1
      "0x632d450318f3347D388Dc0aA4A0feA888c58FBEc", //ETH-AVAX
      "0x310C66526c349784E975790094cbFbe8ae423FCE", //PNG-AVAX
      "0x9d1e250E40676a05b8e1CE256b3f2b9764827dc8", //USDT-AVAX
      "0x888300Be13b8875FeEF00C421d1C4aa7B8eae8Db", //WBTC-AVAX
      // Pangolin V2
      "0x677dCE0683e6Db30325cD97e8d04D138F34821A6", //PNG-AVAX
      // TraderJoe
      "0x6b9E2B2bBd70229E967322F0EdB2d3049990d56D", //SNOB-AVAX
      "0x3739A0d58b0B0aED4B50046a866bd2B9d79b4596", //PEFI-AVAX
      "0x1D4ceE9Bbf71e1c4dAE1A6B1e10C0b4D7C44F96E", //USDT-DAI
      "0xFD6D8C0D5c43195649D5E94f5Db068893b02B866", //YAK-AVAX
      "0x96c3186132955785f05ff10a7495bF096260aF02", //JOE-AVAX
      "0x2F32Fb7C5f3a916fE6b93652F4081b901f2a4701", //XAVA-AVAX
      "0xBAC308B61CA2f0a6693E8696502cb9E04bE5A932", //UST-AVAX
      "0xE58Cf63240417fA2c91c5Bcc92EF1a234eE9bFbA", //USDC-DAI
      "0xa1FEaDD11cd6a27bDFd945eB8EF685d8872639Fa", //USDC-USDT
      "0x17a57f77e31752Ca1455ea7946C7DF54fB4EA876", //ETH-AVAX
      "0xd04B43A8E016ead5c95971e428bffE5a32cFAd3c", //MIM-AVAX
      "0xc05227Adce1a291752E90bC989F71C4c534D26d5", //USDC-AVAX
      "0x20BEEA9FaB7E05b05F110EED0CB4f3B29b3Ddfb4", //USDT-AVAX
      "0x8dFc921Ce9b5fBc94e6aeeFB922327619dc78B62", //gOHM-AVAX
      "0x8A4ADA2e869FEb1A24d19ed4ec5443501036Db4E", //PTP-AVAX
      "0x8335B0323f995f7c698857DFF7a06Ac7ee385347", //sAVAX-AVAX
      // Thorus
      "0xC62Db06fB682593921A0421D56144F6e0Aef27C9", //MIM-AVAX
      "0xdBC45f9952EE3540fFD1609B9664E15771F3cf23", //MIM-STATIK
      "0x5326B5Eb7AC37074a9cCF14aAe5631b622d754e6", //USDC-STATIK
      "0x8369E0311295de318e6e619d3cd60e4c0335F577", //USDT-STATIK
      "0x695A803446cf0B46e326FA7c521c48eAfea0fFcE", //WBTC-STATIK
      "0xCDb2442225F70a4d5De563040ac553Dda323628C", //ETH-STATIK
      "0xc0a11d7B30972538E27120ee3aB862a4a6e02a84", //sTHO-STATIK
      "0x28366F64c4ab4Fd7c2bbFc6aC1635BEdB555d542", //WMEMO-STATIK
      "0x1d43Cb9F1E93ee298610D8b5dE698b61f1D9f5A6", //DAI-STATIK
    ],
    [Factory.V2V2]: [
      // TraderJoe
      "0x8Cba4885a1d6eeFA8c1EbD908797efc742Cb57ac", //JOE-AVAX
      "0xee5d8c763cc3D515F9E0f5A94A253C0da4be0B92", //USDC-AVAX
      "0x69FeAfE1B2FbFE8648fC40fd87599AA47726af52", //ETH-AVAX
      "0x5E1aF8264C267AF3C8cAAFb13307B8476b3F1264", //USDC.e-USDC
      // Pangolin
      "0x664d1384A5FbbeBA59e76582858459722a27e282", //USDC-AVAX
    ],
    [Factory.SOLV2]: [
      // Flair
      "0x25b4CDb937d54D4Db90A38E03F19257F9f7997d2", //IBEX-WETH
      //"0x235D426DD071B0df855AB7EE51314f6a17E477BF", //IBEX-USDT
      "0xeAd9905D4f0d03827015f5801EC14BFdDB8552D4", //AVAX-USDC
      "0x77d96EDA5965505FCAE3333adbE07aA52aD6F536", //AVAX-USDT
      "0x762a00a96b42087E92E140dBA3c96E0e0C430307", //FLDX-USDT
      "0x491A1FDC7e74De8A062aD8340777EDB2B1604eAd", //FLDX-fBOMB
      // Glacier
      "0xB4147A84D68eAACe55c98A76506CbaA0da7e3E74", //AVAX-IBEX
      "0x57aE49863D358142fE57d3C74a302A424003b41e", //USDC-IBEX
      "0x38F33ecF828b0A6c02aD03D4f516cE330eE7bcAf", //fBOMB-GLCR
      "0x4178E39036584De658e32af2a564F35F60Cf18B0", //AVAX-GLCR
    ]
  },
  [Networks.Moonriver]: {
    [Factory.V2V1_2]: [],
  },
  [Networks.Canto]: {
    [Factory.SOLV2]: [],
  },
  [Networks.ZksyncEra]: {
    [Factory.SOLV2]: [],
  },
  [Networks.Aurora]: {},
  [Networks.Cronos]: {},
  [Networks.Fantom]: {
    [Factory.SOLV1_2]: [
      "0xA182c470d4da1BB22742D68167812DF652cd5731", //IB-FTM
      "0xD02C6Cacf356c6B3532bCF79eBFA6c86F99E1b3a", //MULTI-FTM
      "0x5D7e9fAEff7838FE985C72D2b1b083EC74F42586", //GEIST-FTM
      "0xf886230371E4C14B5F68A7172520C555B7841ca6", //YFI-FTM
      "0x6Be064F12443260E72332A485a57588a6849a02D", //YFI-WOOFY
      "0x1522929BFFdD83DA2a1B9441d35AC237F8a280c0", //DEI-DEUS
      "0x24814e227711aeAD121f5B25a527683869425228", //OXDv2-FTM
      "0x01e8d0ce9e944f6BB7fA827F3E05cDcd141ef26b", //SOLID-oxSOLID
      "0x1ec7bfEd79888240B074022Fcd2228f0F06532F4", //DEI-SCREAM
      // Deprecate FTM pairs update (17/05/2024)
      "0x6Cf576EFdc204435469C8Dc42fadF762E5b92002", //SOLID-FTM
      "0x6e38293CB8FC924b31Db6AD523b29A1f82795Db7", //TOMB-FTM
      "0x03Ac376Bc726D0709cDfF45E3b1e082F11c2f552", //FRAX-FTM
      "0xA55C1515CccEE00E86Cb9263827A6CD07D47Bf67", //SYN-FTM
      "0x426be5A672638c9a167242a4BE2240ce854560ac", //SEX-FTM
      //"0xe08b9bBe222aE0F750bA3C0a538757b94f21db4D", //FXS-FRAX
      "0x14e78aAb7465dB00aE2fe5791fDA07eda5c71AA1", //SCREAM-FTM
      "0x6D8e992997BAae22D9CB1c179E88b505c774be4e", //HND-FTM
      "0x99A29a00afc4fcb9D8d60c706A47C8e6Efd48B3F", //LQDR-FTM
      "0xCa72DE89f202e836DF6eDD80a7985B81Ba90A227", //BEETS-fBEETS
      "0x93a2C9b060512E67E85B85996A62d273c81D16D1", //BOO-xBOO
      "0xDBFA79D2aee386D0B441De9AA8Ddc9caAa6E260E", //RDL-FTM
      "0xa9969450fbBcFa62CaBdcd373C9BB4845A4Bc9F0", //TAROT-FTM
      "0xb0896E6b628589F2c3c6A8958a6ba3B58a533D7c", //OATH-FTM
      "0xe86595d392dCF6eC8e667A21efD41c114D31B322", //renBTC-FTM
      "0x4691544932BF8BAAc2E158505A4Cb542F4F283C8", //TOMB-MIMATIC
      //"0xAf2FFcDE11321312FdD6D024d58854De72EAD3F5", //CRV-g3CRV
      //"0x6EFB5ED1485A4e029e964282bdC31Cc24Adb7740", //SOLIDsex-g3CRV
      //Autocompounder B
      "0xd73BE67104D11a5d9b43E9E6EDeaD48dD39944E1", //FRAX-FXS
    ],
    [Factory.SOLV2]: [
      "0x16875107bB3CE4b0c120c95B3B8d3f94d799C0Ef", //TOMB-FTM oxd
      "0x65151e7A82c4415A73756608E2C66b39A57dcA12", //OXDv2-FTM oxd
    ],
  },
  [Networks.Harmony]: {},
  [Networks.Moonbeam]: {},
  [Networks.Sxnetwork]: {},
  [Networks.Base]: {
    [Factory.SOLV2]: [
      "0xed7752e6D91D7cB171A22A8FB5a0E60F4D38dB11", // uSol/fbomb stakedlp
      "0x753ea0ADE9cbFF68CBAFFaEdf7863B8225c93a64", // usdc/fbomb stakedlp
      "0xb432A29F1374129f49d41Bd80932BD164ce4C984", // aero/l2ve stakedlp
    ],
  },
  [Networks.Mantle]: {
    [Factory.V2V1]: [],
  },
  [Networks.Scroll]: {
    [Factory.SOLV2]: [
      "0xDA4ca9030d4c037203F4cA2a1A191EfA209FA6f1", // fbomb/wsteth stakedlp
    ]
  },
  [Networks.Real]: {
    [Factory.SOL_STABLE]: [
      "0xd24F497f0e877203d716eE147FE96858121E437a", // more/usdc stakedlp
    ],
    [Factory.SOLV2]: [
      "0x1f0bc333c535838CA1020c87a6a043D89577c563", // usdc/pearl stakedlp
    ]
  },
  [Networks.Optimism]: {
    [Factory.SOLV2]: [],
  },
  [Networks.Blast]: {
    [Factory.SOLV2]: [],
  },
  [Networks.Sonic]: {
    [Factory.SOLV2]: [
      // shadow pools
      "0x4641B75833a760902F001Aed68ECcE8E366F3F97", // ws/mclb stakedlp
      "0xEd4C75659254CC19c8412e17896fA040829DEEBA", // ws/fa stakedlp
      "0x13719Aecc00dE4f653C4CC36921D3Cb5209c17e7", // ws/thc stakedlp
      "0xE821FE9a6C018070dc0E42fA4EAE9b333289cE7b", // shadow/shedew stakedlp
    ],
  },
  [Networks.Linea]: {
    [Factory.SOLV2]: [
      // nile
      "0x6F988b0810C9F26e653982f0c55872ffe618801C", // nile/weth stakedlp
      "0xFa8268Ab238c3FFAD3f96693088d569b70eF9300", // zero/eth
      "0x05EFe1133d9ca372017647e0e71174517C663683", // lpluss/eth
      "0xf45e449fAC0E910F2736FF45eF8ff9ff4b6112Ac", // usdc/nil
    ],
    [Factory.SOL_STABLE]: [
      // nile stable
      "0x09a3179372728C01fd03a27F8EC893ce8AD8B14d", // usdc/grai stakedlp
    ],
  },
  [Networks.HyperEVM]: {}
};

// TODO
// SHOW WARNING IF A USER HAVE FUNDS DEPOSITED IN A BLACKLISTED PAIR AND THEY CAN BE WITHDRAWN

export const BLACKLISTED: NetworkFactoryIndex<Address[]> = {
  [Networks.Ropsten]: {},
  [Networks.Mainnet]: {
    [Factory.V2V1]: [
      "0xa00d47b4b304792eb07b09233467b690db847c91", //IMX-ETH
      "0x46af8ac1b82f73db6aacc1645d40c56191ab787b", //NDX-ETH
      "0x8dcba0b75c1038c4babbdc0ff3bd9a8f6979dd13", //DEFI5-ETH
      "0x08650bb9dc722c9c8c62e79c2bafa2d3fc5b3293", //AMP-ETH
    ],
  },
  [Networks.Polygon]: {
    [Factory.V2V1_1]: [
      // QuickSwap
      "0x5ed3147F07708A269f744B43c489e6Cf3B60aEC4", //DAI-USDT
      "0x87B94444d0f2c1e4610A2De8504D5d7b81898221", //QUICK-POLYDOGE
      "0x5f819f510ca9b1469e6a3ffe4ecd7f0c1126f8f5", //IMX-ETH [OLD]
      "0xb957D5a232EEbD7C4c4B0A1af9F2043430304E65", //rUSD-USDC
      "0x23312FCEADb118381C33B34343A61c7812f7a6a3", //IMX-ETH
      "0x76483D4Ba1177F69FA1448dB58d2f1dBE0Fb65fa", //IMX-QUICK
      "0xD4f5F9643A4368324aC920414781B1c5655BaeD1", //IMX-QUICK
      "0x8ce3bf56767dD87E87487f3fae63e557B821Ea32", //IMX-WETH
    ],
    [Factory.V2V2]: [
      "0x8ce3bf56767dd87e87487f3fae63e557b821ea32", //IMX-ETH
    ],
    [Factory.SOLV2]: [
      // Pearl
      "0x2712fbb291d8784b7bf75e50f472968d0bd43fc1", //USDR-ETH
      "0x7c91c66f7df3d23858937b0d419fd10b72bdc6d3", //USDR-BTC
      "0xbde0990EeB2509931a0f73f78010F00191D746BA", //USDR-MATIC
      "0x281Db118b0CB2865d9370c98AaC6e42523582AED", //USDR-PEARL
      "0x822363B6dFaa8C41c1ADa904F1829143375EA6Da", //USDR-TNGBL
      "0x6467FeF60a061f541967415fcBcDFb6Dc964f711", //USDR-IBEX
      // Satin
      "0x7166f0509bd1deedf90e42046025d929078089b4", //MATIC-LIBERA
      "0x06D3AE1Cfe7D3D27B8b9f541E2d76e5f33778923", //SATIN-CASH
      "0x3E626179241585235FF7B002cc4dC5439338990e", //IBEX-WETH
      "0xCB091859dd1d994d513721fB9722Ca9f8839A825", //ETH-CASH
      "0x7b750A5C4c0c7b36D206383353AB3c54DeE74deF", //MATIC-CASH
    ],
  },
  [Networks.Arbitrum]: {
    [Factory.V2V1_1]: [
      // Sushiswap
      "0xB7E5e74B52b9aDa1042594Cfd8AbbdeE506cc6C5", //ETH-IMX
      "0x8884cc766b43ca10ea41b30192324c77efdd04cd", //ETH-NYAN
      // Swapr
      "0xCC5c1540683AFF992201d8922DF44898E1Cc9806", //IMX-ETH
    ],
  },
  [Networks.Avalanche]: {
    [Factory.V2V1_2]: [
      // Traderjoe
      "0x21249FC0Ad45fB3e33C12BE0fA2B81000A290C5f", //SPELL-AVAX
      "0xa34862a7de51a0e1aee6d3912c3767594390586d", //IMX-AVAX OLD
      // Pangolin V1
      "0xE9439f67201894C30F1C1c6b362F0e9195FB8e2C", //IMX-AVAX
      // Pangolin V2
      "0xde0037aFbE805C00d3CEc67093A40882880779b7", //IMX-AVAX
      "0x69c1C44e8742b66D892294a7EEB9aac51891B0EB", //USDC-UST
      "0xc6E68d77d0f4FA925A1cF2611dAB6b10900Eaf2B", //UST-AVAX
      // Thorus
      "0xd60709441b483453e84aD8E1C30F2e9EE116851D", //USDC-THO
    ],
    [Factory.V2V2]: [
      // Pangolin
      "0xE429Fbdc3275e29cA4c11F9c1EB4C8Cee1fCAda3", //WBTC-USDC
      "0xc532a2885027677c4BE61F710F7D41941dBaD1B1", //ETH-AVAX
      "0x677dCE0683e6Db30325cD97e8d04D138F34821A6", //PNG-AVAX
      "0x65A9a0b25A2397e67Fe688361Bf4113cf4Fa5313", //USDT-AVAX
    ],
    [Factory.SOLV2]: [
      // Glacier
      "0x96f1F13865f11E2EC0E15051415f420dAC440EC1", //WETH-USDT.e
      "0x674A38dE6dC83FBde29784C9A974D38a11EbFB37", //BTC.b-AVAX
      "0x4ab56108FD36F5da28b56a43b17909f745d560e4", //AVAX-USDT
      "0x29327d37Ee0395a22dd419E2E81F3Bf2da066cfe", //GMX-USDC
      "0x0d4E0EaFA9002957371a0cadbD3BF168d6D0741A", //fBOMB-AVAX
      "0x7AEDD611c361cfc53d14953A6CbDC2d4Cd48AC94", //AVAX-WMEMO
      //"0x8dc6fae7fedd7a60ecbb27c17af830f5811d773e", //MMTH-BTC.b
    ],
  },
  [Networks.Moonriver]: {
    [Factory.V2V1_2]: [
      // SolarBeam
      "0x6ed3bc66dfcc5ac05daec840a75836da935fac97", //IMX-MOVR
    ],
  },
  [Networks.Canto]: {
    [Factory.SOLV2]: [],
  },
  [Networks.ZksyncEra]: {
    [Factory.SOLV2]: [],
  },
  [Networks.Aurora]: {},
  [Networks.Cronos]: {},
  [Networks.Fantom]: {
    [Factory.SOLV1_2]: [
      "0x877a330AF63094d88792b9Ca28AC36C71673EB1C", //IMX-FTM
      "0xb97B6eD451480FE6466a558E9C54EaAC32e6C696", //OXD-FTM
      "0xC64b5c901df0c4F6059059772F8440535C3bf5dd", //USDC-WeVE
      "0xBfBF0EBDC3D5E8692F9A27d47f250afe4867A647", //BIFI-MIMATIC
      "0xAC6542586c8A7b7aB522e77997414eafD9a83c11", //CRV-FTM
      "0x228BE1a38437312C649711f1BFf28d99e9E749B6", //SOLIDsex-FTM
    ],
  },
  [Networks.Harmony]: {},
  [Networks.Moonbeam]: {},
  [Networks.Sxnetwork]: {},
  [Networks.Base]: {
    [Factory.SOLV2]: [],
  },
  [Networks.Mantle]: {
    [Factory.V2V1]: [],
  },
  [Networks.Scroll]: {
    [Factory.SOLV2]: [
      "0x94d81405985A4c34EaC4945d2b98c74258EdD07F", // tkn/chi - stakedlp
      "0xE8f4895DF06a0c69A9BA87509EfdBBFBAFe86c2d", // weth/tkn - stakedlp
      "0x7c80Be56a6f23A3E598822648baaFD7524fe1239", // chi/wUKRE stakedlp
      "0xC90073E1CaBCf5069E00c5a6cB10023c9e1D5c4f", // wbtc/weth - stakedlp
    ],
    [Factory.SOL_STABLE]: [
      "0xDD14d0c651C63e1EeA5bd8b250cf99757425D68F", // chi/usdc stakedlp
    ]
  },
  [Networks.Real]: {
    [Factory.SOL_STABLE]: [],
  },
  [Networks.Optimism]: {
    [Factory.SOLV2]: [],
  },
  [Networks.Blast]: {
    [Factory.SOLV2]: [],
  },
  [Networks.Sonic]: {
    [Factory.SOLV2]: [
      "0xD9De9f15994182518a688933d09787A9a9fb5bc9", // ws/shadow stakedlp
    ],
  },
  [Networks.Linea]: {
    [Factory.SOLV2]: [],
  },
  [Networks.HyperEVM]: {}
};

// Disabled lending pools leverage/borrows in case of risky pairs
export const DISABLED_BORROWS: NetworkIndex<Array<Address> > = {
  [Networks.Ropsten]: [],
  [Networks.Mainnet]: [],
  [Networks.Polygon]: [],
  [Networks.Arbitrum]: [],
  [Networks.Avalanche]: [],
  [Networks.Moonriver]: [],
  [Networks.Aurora]: [],
  [Networks.Cronos]: [],
  [Networks.Fantom]: [],
  [Networks.Harmony]: [],
  [Networks.Moonbeam]: [],
  [Networks.Sxnetwork]: [],
  [Networks.Canto]: [],
  [Networks.ZksyncEra]: [],
  [Networks.Base]: [],
  [Networks.Mantle]: [],
  [Networks.Scroll]: [
    "0xdd14d0c651c63e1eea5bd8b250cf99757425d68f", // USDC/CHI
  ],
  [Networks.Real]: [],
  [Networks.Optimism]: [],
  [Networks.Blast]: [],
  [Networks.Sonic]: [],
  [Networks.Linea]: [],
  [Networks.HyperEVM]: []
};

/*export const OLD_FARMS: {[key in Address]: Address[]} = {
  '0xb0e7ad5053414fde098122b61fd34d816fd6d93f': [
    '0x42f530ac803ff361c35d4cd8779406c85b76fb59',
    '0x25ce67b9a3431088d352747f46fffcccfe73f94c',
  ],
  '0x7532a8d8a12bdd871796a07ac90e510b1cc8f694': [
    '0x247787c978e7f5ac0128a2477e0e0d3dc89e40ce',
    '0x9bcbfedf8c4583bc611f6bb445e11681a12c5f89',
  ],
  '0x95c9bf3f60cbc2be8e148fae82f26930bfcd1839': [
    '0xb0e69a8e9da7bdcb14bed2959f41035d7f3aefcf',
    '0x1c2d150edf7d2bd70fe52be62625b7d3a01ca4f9',
  ],
  '0xb7e5e74b52b9ada1042594cfd8abbdee506cc6c5': [
    '0x2da32c6cdf41b11b0103214475adeb1d91a04221',
    '0x7f09f13f6b19c2bf92258e6709b7c2cf503ef0fb',
  ],
};*/
